/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:599px){.listing-card.commercial.listing-details[_ngcontent-%COMP%]   .courtesy[_ngcontent-%COMP%]{text-transform:uppercase;margin:10px 0}}@media (max-width:1199px){.listing-card.listing-details[_ngcontent-%COMP%]{max-height:initial}}"];
export { styles as styles };
